import type { TaxScenarioInput } from '@/tax/types';

type PensionInput = Pick<TaxScenarioInput,
  'filingStatus' | 'govtPensionTP' | 'govtPensionSP' | 'nonGovtPensionTP' | 'nonGovtPensionSP' | 'militaryRetirementPension'>;

/**
 * The Pension Sum the Income step shows and the Excel export prints: the five
 * pension boxes, the same total the engine taxes (getComputedPensionSum). The
 * spouse's two count only on a joint return, as in the engine.
 */
export function pensionTotal(input: PensionInput): number {
  const joint = input.filingStatus === 'MFJ';
  return (input.govtPensionTP || 0) + (input.nonGovtPensionTP || 0) + (input.militaryRetirementPension || 0)
    + (joint ? (input.govtPensionSP || 0) + (input.nonGovtPensionSP || 0) : 0);
}
